import { EditorSelection } from '@codemirror/state';
// import { EditorView } from '@codemirror/view';
import {
  completionStatus,
  acceptCompletion,
  moveCompletionSelection,
} from '@codemirror/autocomplete';

import { getToken, getTokenAtPos } from './utils';
import { INVALID_COMMANDS, TOKEN_TYPES } from './consts';

function moveToMetricGroupEnd(view) {
  const { state, dispatch } = view;
  const token = getToken(state, 1);

  const nextToken = getTokenAtPos(state, token.to + 1, -1);
  if (
    token.name === TOKEN_TYPES.OPERATOR &&
    (nextToken.name === TOKEN_TYPES.OPERATOR ||
      nextToken.name === TOKEN_TYPES.METRIC)
  ) {
    const newPos = EditorSelection.cursor(nextToken.from);
    const transaction = state.update({
      selection: newPos,
      scrollIntoView: true,
    });
    dispatch(transaction);
    return true;
  }
}

function moveToMetricGroupStart(view) {
  const { state, dispatch } = view;
  const token = getToken(state, -1);

  const nextToken = getTokenAtPos(state, token.from - 1, 1);
  if (
    token.name === TOKEN_TYPES.OPERATOR &&
    (nextToken.name === TOKEN_TYPES.OPERATOR ||
      nextToken.name === TOKEN_TYPES.METRIC)
  ) {
    const newPos = EditorSelection.cursor(nextToken.to);
    const transaction = state.update({
      selection: newPos,
      scrollIntoView: true,
    });
    dispatch(transaction);
    return true;
  }
}

function deleteMetricGroup(view) {
  const { state, dispatch } = view;
  const token = getToken(state, -1);

  if (token.name === TOKEN_TYPES.OPERATOR) {
    dispatch(
      state.update({
        changes: { from: token.from, to: token.to, insert: '' },
        scrollIntoView: true,
      })
    );

    return true;
  }
}

export const keymapList = [
  // autocompletion edge case(to fix ko not working)
  {
    key: 'ArrowUp',
    preventDefault: true,
    run: (view) => {
      if (completionStatus(view.state)) {
        moveCompletionSelection(false)(view);
        return true;
      }

      return false;
    },
  },
  {
    key: 'ArrowDown',
    preventDefault: true,
    run: (view) => {
      if (completionStatus(view.state)) {
        moveCompletionSelection(true)(view);
        return true;
      }

      return false;
    },
  },
  {
    key: 'Enter',
    preventDefault: true,
    run: (view) => {
      if (completionStatus(view.state)) {
        acceptCompletion(view);
        return true;
      }

      // block enter at the beginning of a line
      const pos = view.state.selection.main.head;
      const line = view.state.doc.lineAt(pos);
      if (pos === line.from) return true;

      return false;
    },
  },
  // modify edge case
  {
    key: 'Alt-ArrowRight',
    preventDefault: true,
    run: moveToMetricGroupEnd,
  },
  {
    key: 'Alt-ArrowLeft',
    preventDefault: true,
    run: moveToMetricGroupStart,
  },
  {
    key: 'Alt-Backspace',
    preventDefault: true,
    run: deleteMetricGroup,
  },
  // turn off invalid keymap
  ...INVALID_COMMANDS.map((key) => ({
    key,
    preventDefault: true,
    run: () => true,
  })),
];
